import React, {useContext} from 'react';
import {Card, CardContent, CardHeader, Typography} from "@mui/material";
import StoricoTicket from "./StoricoTicket";
import {TicketContext} from "../../../../App";
import {TicketStyle} from "../../../../styles/pages/tickets/TicketStyle";

const StoricoCard = ({children, useStringify=false}) => {
	const ticketClasses = TicketStyle();
	const ticketContext = useContext(TicketContext);
	
	return (
		<React.Fragment>
			<Card className={ticketClasses.ticketDetailPanel} elevation={0} style={{display: "flex", flexDirection: "column"}}>
				<CardHeader
					title={<Typography variant={"h6"}><b>Storico ticket</b></Typography>}
					subheader={"Qui trovi lo storico del ticket in questione"}
				/>
				<CardContent className={ticketClasses.ticketDetailPanelContent}>
					<StoricoTicket
						storicoTicket={ticketContext.state.ticketHistory}
						useStringify={useStringify}
						variant="timeline"
						ticketClasses={ticketClasses}
					/>
					{children}
				</CardContent>
			</Card>
		</React.Fragment>
	);
};

export default React.memo(StoricoCard)
